module.exports = {"DATE_SELECT_DAY":"Hari","DATE_SELECT_MONTH":"Bulan","DATE_SELECT_YEAR":"Tahun"}